import React, { useEffect } from 'react';
import { useGameState } from '../contexts/GameStateContext';
import { useConnection } from '../contexts/ConnectionContext';
import { usePlayer } from '../contexts/PlayerContext';

const MapSelector = () => {
  const { selectedMap, availableMaps } = useGameState();
  const { emitGetAvailableMaps, emitChangeMap } = useConnection();
  const { isObserver, myPlayerId } = usePlayer();

  // Request available maps when component mounts
  useEffect(() => {
    // Try immediately
    emitGetAvailableMaps();
    
    // Retry after a short delay if maps aren't loaded
    const retryTimer = setTimeout(() => {
      if (availableMaps.length === 0) {
        emitGetAvailableMaps();
      }
    }, 1000);
    
    return () => clearTimeout(retryTimer);
  }, [emitGetAvailableMaps, availableMaps.length]);

  const canChangeMap = !isObserver && myPlayerId === 0;

  const handleMapChange = (mapId) => {
    if (canChangeMap) {
      emitChangeMap(mapId);
    }
  };

  if (availableMaps.length === 0) {
    return (
      <div style={{
        marginBottom: '10px',
        padding: '8px',
        backgroundColor: '#2a2a2a',
        borderRadius: '4px',
        border: '1px solid #444',
        textAlign: 'center'
      }}>
        <span style={{ color: '#888', fontSize: '14px' }}>Loading maps...</span>
      </div>
    );
  }

  return (
    <div style={{
      marginBottom: '15px',
      padding: '12px',
      backgroundColor: '#2a2a2a',
      borderRadius: '6px',
      border: '1px solid #444'
    }}>
      <h3 style={{ 
        color: '#fff', 
        margin: '0 0 10px 0', 
        fontSize: '16px',
        textAlign: 'center'
      }}>
        🗺️ Map Selection
      </h3>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {availableMaps.map(map => (
          <div
            key={map.id}
            onClick={() => handleMapChange(map.id)}
            style={{
              padding: '10px',
              backgroundColor: selectedMap === map.id ? '#4a7c59' : '#333',
              border: selectedMap === map.id ? '2px solid #5a9664' : '1px solid #555',
              borderRadius: '4px',
              cursor: canChangeMap ? 'pointer' : 'not-allowed',
              opacity: canChangeMap ? 1 : 0.6,
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              if (canChangeMap && selectedMap !== map.id) {
                e.target.style.backgroundColor = '#404040';
              }
            }}
            onMouseLeave={(e) => {
              if (canChangeMap && selectedMap !== map.id) {
                e.target.style.backgroundColor = '#333';
              }
            }}
          >
            <div style={{ 
              color: '#fff', 
              fontWeight: selectedMap === map.id ? 'bold' : 'normal',
              fontSize: '14px',
              marginBottom: '4px'
            }}>
              {selectedMap === map.id && '✓ '}{map.name}
            </div>
            <div style={{ 
              color: '#bbb', 
              fontSize: '12px',
              lineHeight: '1.3'
            }}>
              {map.description}
            </div>
          </div>
        ))}
      </div>
      
      {!canChangeMap && (
        <div style={{
          marginTop: '8px',
          textAlign: 'center',
          color: '#888',
          fontSize: '12px'
        }}>
          {isObserver ? 'Observers cannot change the map' : 'Only Player 1 (host) can change the map'}
        </div>
      )}
    </div>
  );
};

export default MapSelector;